module.exports = __webpack_public_path__ + "img/DE00151.1109fc2b.png";